import { VStack, Text, Box } from "@bpba/ui-components";
import { Faq } from "./Faq";
import { FeedbackStorageManager } from "./FeedbackStorageManager";
import { useState } from "react";
import { BP_CONTAINER_PAD_Y, BP_CONTAINER_PAD_X } from "../../constants/data";
import { GenericComponentProps } from "../../model/GenericComponentProps";
import { PreguntaData } from "../../model/preguntas/PreguntaData";
import styled from "styled-components";
import { ErrorBoundary } from "../ErrorBoundary";

export function FaqContainer(props: GenericComponentProps<PreguntaData>) {
  const { moduloTitulo, data, backgroundColor } = props;
  const feedbackStorageManager = new FeedbackStorageManager();
  const [selected, setSelected] = useState<string | undefined>(undefined);

  if (!data || data.length === 0) return <></>;

  return (
    <ErrorBoundary>
      <StyledContainer
        backgroundColor={backgroundColor || "secondary.0"}
        justifyContent="center"
        paddingY={BP_CONTAINER_PAD_Y}
        paddingX={BP_CONTAINER_PAD_X}
        paddingBottom={["40px"]}
      >
        <VStack maxWidth={["100%", 438, 645, 788]}>
          <Text
            fontSize={[22, 28]}
            lineHeight={["27px", "37px"]}
            fontWeight="400"
            textAlign="center"
            marginTop={0}
            marginBottom={["24px !important", "40px !important"]}
            tabIndex={0}
          >
            {moduloTitulo}
          </Text>
          {data.map((preguntaData, index) => (
            <Faq
              item={preguntaData}
              key={index}
              index={index + 1}
              feedbackStorage={feedbackStorageManager}
              backgroundColor={backgroundColor}
              isOpen={!!preguntaData?.id && selected === preguntaData.id}
              setOpen={setSelected}
            />
          ))}
        </VStack>
      </StyledContainer>
    </ErrorBoundary>
  );
}

const StyledContainer = styled(Box)({
  boxSizing: "border-box",
});
